module.exports = __webpack_public_path__ + "img/empty-2.724447e7.png";